<template>
    <div class="adw-root">
        <div class="adw-filters">
            <div class="adw-filter">
                <datepicker :dateFrom="dateFrom" :dateTo="dateTo" :min="dateWeekAgo" :max="new Date()" @dateChanged="dateChanged"></datepicker>
            </div>
            <div class="adw-filter adw-devices">
                <p class="adw-filter-title">{{ $t('Device') }}</p>
                <devices-select
                    :system-id="systemId"
                    :pre-loaded-devices="devices"
                    :pre-selected-device="deviceObj"
                    :date-from="dateFrom"
                    :date-to="dateTo"
                    @deviceChanged="(dev) => selectedDevice = dev"
                ></devices-select>
            </div>
        </div>

        <alarm-day-timeline
            v-if="alarms != null"
            rows-by="day"
            :alarms="alarms"
            :range-from="dateFrom"
            :range-to="dateTo"
            max-body-height="60vh"
        ></alarm-day-timeline>
    </div>
</template>

<script>
import Datepicker from '../Datepicker.vue'
import DevicesSelect from '../Filters/DevicesSelect'
import AlarmDayTimeline from './AlarmDayTimeline.vue'
import { getDevicesForSystem, getLastWeekAlarmsForSystemPerDevice } from '@api'

// Tydzień alarmów jednego urządzenia: wiersz = dzień, oś X = godzina doby, kolor = typ.
// Zastępuje SciChartPerDevice w widokach Alarmy i Ustawienia → Alarmy (te same propsy).
export default {
    name: 'AlarmDeviceWeek',
    components: { Datepicker, DevicesSelect, AlarmDayTimeline },
    props: ['systemId', 'allAlarmTypes', 'deviceObj'],
    data() {
        const weekAgo = new Date()
        weekAgo.setDate(weekAgo.getDate() - 7)
        const dateWeekAgo = new Date(weekAgo.getFullYear(), weekAgo.getMonth(), weekAgo.getDate())

        return {
            dateWeekAgo,
            dateFrom: dateWeekAgo,
            dateTo: new Date(),
            devices: [],
            selectedDevice: null,
            alarms: null
        }
    },
    watch: {
        selectedDevice(device) {
            if (device != null) this.loadAlarms()
        }
    },
    methods: {
        dateChanged(dateFrom, dateTo) {
            this.dateFrom = dateFrom
            this.dateTo = dateTo
            this.loadAlarms()
        },
        async loadDevices() {
            const devices = await getDevicesForSystem(this.systemId, this.dateFrom, this.dateTo)
            this.devices = devices.sort((a, b) => a.number - b.number)

            const preselected = this.deviceObj != null
                ? this.devices.find(x => x.id === this.deviceObj.deviceId)
                : null
            this.selectedDevice = preselected || this.devices[0] || null
        },
        async loadAlarms() {
            if (this.selectedDevice == null) return
            const device = this.selectedDevice
            const groups = await getLastWeekAlarmsForSystemPerDevice(device.id, this.dateFrom.toISOString(), this.dateTo.toISOString())
            // Odpowiedź sprzed zmiany urządzenia nie może nadpisać nowszej.
            if (device !== this.selectedDevice) return

            // Grupy {item1: id typu, item2: alarmy} spłaszczone do listy dla osi czasu.
            const types = this.allAlarmTypes || []
            this.alarms = groups.flatMap(group => {
                const type = types.find(t => t.id == group.item1)
                const typeName = type != null ? this.$t(type.description) : group.item1
                return group.item2.map(a => ({
                    id: a.id,
                    alarmTypeId: group.item1,
                    alarmType: typeName,
                    description: a.description,
                    createDate: new Date(a.createDate),
                    endDate: new Date(a.endDate),
                    isActive: a.isActive,
                    deviceId: device.id,
                    number: device.number,
                    type: ''
                }))
            })
        }
    },
    mounted() {
        this.loadDevices()
    }
}
</script>

<style scoped>
.adw-root {
    width: 90vw;
    min-height: 60vh;
}

.adw-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    padding: 8px 12px 0;
}

.adw-devices {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
}

.adw-filter-title {
    margin: 0;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-strong);
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/AlarmDeviceWeek.vue